/**
 * Allows iteration over a NodeList
 * */
NodeList.prototype[Symbol.iterator] = Array.prototype[Symbol.iterator];

/**
 * Extend `NodeList` prototype to provide a `Array`-like interface
 * */
NodeList.prototype.find = Array.prototype.find;
NodeList.prototype.filter = Array.prototype.filter;



// WEBPACK FOOTER //
// ./app/assets/javascripts/polyfills/nodeListIterator.js